import { CommonEnums } from '../../common.enums';
import { Looper } from './looper';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { RepConn } from '../datapoint/repconn';
import { Flagent } from '../datapoint/flagent';
import { Flagent_Grp } from '../datapoint/flagent_grp';

export class LoopStart {
    looper: Looper;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: string;
    fldr_Id: string;
    conn_Db_Obj_Lnk: Conn_Db_Obj_Lnk;
    flagent: Flagent;
    flagent_Grp: Flagent_Grp;
    ref_Cd: string;
    repConn: RepConn;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.looper = new Looper();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.STRING_EMPTY;
        this.conn_Db_Obj_Lnk = new Conn_Db_Obj_Lnk();
        this.flagent = new Flagent();
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.repConn = new RepConn();
    }

    static parse(loopStartTmp: LoopStart): LoopStart {
        let loopStart: LoopStart = new LoopStart();
        loopStart.copyFrom(loopStartTmp);
        return loopStart;
    }

    copy(): LoopStart {
        let loopstartTmp: LoopStart = new LoopStart();

        loopstartTmp.looper = this.looper.copy();
        loopstartTmp.change_Ind = this.change_Ind;
        loopstartTmp.error_Cd = this.error_Cd;
        loopstartTmp.error_Msg = this.error_Msg;
        loopstartTmp.ref_Id = this.ref_Id;
        loopstartTmp.fldr_Id = this.fldr_Id;
        loopstartTmp.conn_Db_Obj_Lnk = this.conn_Db_Obj_Lnk.copy();
        loopstartTmp.flagent = this.flagent.copy();
        loopstartTmp.ref_Cd = this.ref_Cd;
        loopstartTmp.repConn = this.repConn.copy();

        return loopstartTmp;
    }

    copyFrom(loopstartTmp: LoopStart): void {
        this.looper.copyFrom(loopstartTmp.looper);
        this.change_Ind = loopstartTmp.change_Ind;
        this.error_Cd = loopstartTmp.error_Cd;
        this.error_Msg = loopstartTmp.error_Msg;
        this.ref_Id = loopstartTmp.ref_Id;
        this.fldr_Id = loopstartTmp.fldr_Id;
        this.conn_Db_Obj_Lnk.copyFrom(loopstartTmp.conn_Db_Obj_Lnk);
        this.flagent.copyFrom(loopstartTmp.flagent);
        this.ref_Cd = loopstartTmp.ref_Cd;
        //this.repConn.copyFrom(loopstartTmp.repConn);
        if (loopstartTmp.repConn) {
            this.repConn.copyFrom(loopstartTmp.repConn);
        }

    }

    compare(loopstartTmp: LoopStart): string {
        let diffString = '';

        diffString = (this.looper).compare(loopstartTmp.looper);
        if (diffString != '') return diffString;

        if (this.conn_Db_Obj_Lnk.toString() != loopstartTmp.conn_Db_Obj_Lnk.toString())
            return 'diff';

        return diffString;
    }

    toString(): string {
        return "LoopStart [looper=" + this.looper.toString() +
            ", change_Ind =" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", fldr_Id=" + this.fldr_Id +
            ", conn_Db_Obj_Lnk=" + this.conn_Db_Obj_Lnk.toString() +
            ", flagent=" + this.flagent.toString() +
            ", ref_Cd=" + this.ref_Cd +
            ", repConn=" + this.repConn.toString() + "]"
    }
}
